import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { PriceBreakdownDropdown } from "./component";
import {
  getFlightTotalInPrices,
  currentPriceDropProtectionSelector,
  getFlightPriceWithChfarDiscountApplied,
  getIsChfarExerciseBooking,
} from "../../reducer";

const mapStateToProps = (state: IStoreState) => {
  const isChfarExercise = getIsChfarExerciseBooking(state);
  return {
    flightTotal: isChfarExercise
      ? getFlightPriceWithChfarDiscountApplied(state)
      : getFlightTotalInPrices(state),
    priceDropProtection: currentPriceDropProtectionSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PriceBreakdownDropdownConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPriceBreakdownDropdown = connector(
  PriceBreakdownDropdown
);
